import { multipleFieldBase } from '@app/shared/constants/configs/multipleFieldBase';

export const multipleFieldFormattingProps = {
  ...multipleFieldBase,
};
